import { makeStyles } from '@mui/styles';
import { muiTheme } from '@tassat/payments-themes';

export default makeStyles((theme: typeof muiTheme) => ({
    root: {
        width: '95%',
        padding: '0 .5rem',
        alignItems: 'flex-start !important'
    },
    dummyWrapper: { '& > :not(input)': { height: 0 }},
    selected: { color: 'hsl(0,0%,20%)' },
    walletValueSelectWrapper: {
        color: theme?.app?.applicationColors.enumColors.black || '#000',
        display: 'flex',
        flexFlow: 'row',
        flexGrow: 1,
        alignItems: 'center',
        minWidth: '100%'
    },
    walletValueSelect: {
        display: 'flex',
        flexFlow: 'row',
        flexGrow: 1,
        alignItems: 'center',
        '&__left': { flexGrow: 1 },
        '&__right': {
            paddingLeft: '1rem',
            paddingRight: '1rem',
            borderLeft: '1px solid #E4E4E4'
        }
    }
}));